import BasicModal from '../common/BasicModal';
import { ChangeEvent, FC, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CampaignContext } from '../../contexts/CampaignContext';
import { Box, Button, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField, Typography } from '@mui/material';
import axios from 'axios';
import IResponse from '../../interfaces/response';
import { ISmsPanel } from '../../interfaces/campaign';
import { getFarsiNumber } from '../../utils/number';

type IAddPostModal = {
	open: boolean;
	onClose: () => void;
	handleSaveNotSocial: (e: any) => void;
};

type IJobsSelectBox = {
	id: number;
	title: string;
	is_active: boolean;
};

const SmsPanelModal: FC<IAddPostModal> = ({ open, onClose, handleSaveNotSocial }) => {
	const { t } = useTranslation();
	const { selectedContentType, selectedPlatform, selectedPlatformId, selectedMediaTypeId } = useContext(CampaignContext);
	const [location, setLocation] = useState<ISmsPanel[] | null>(null);
	const [operator, setOperator] = useState<string | null>(null);
	const [province, setProvince] = useState<number | null>(null);
	const [neighborhoodId, setNeighborhoodId] = useState<string | null>(null);
	const [jobs, setJobs] = useState<IJobsSelectBox[]>([]);
	const [gender, setGender] = useState<string>('');
	const [age, setAge] = useState<IJobsSelectBox[]>([]);
	const [text, setText] = useState<string>('');
	const [count, setCount] = useState<number>(0);
	const [setting, setSetting] = useState<any>([]);
	const [selectJobs, setSelectJobs] = useState<string | null>(null);
	const [selectAge, setSelectAge] = useState<string | null>(null);
	// const [resultSms, setResultSms] = useState<number>(0);

	useEffect(() => {
		setText('');
		setGender('');
		setSelectAge('');
		setText('');
		setCount(0);
		setSelectJobs('');
		setNeighborhoodId('');
		setProvince(null);
	}, [selectedPlatform, selectedMediaTypeId, selectedContentType]);
	function calculateSMSPrice() {
		let operatorSelected;
		if (operator === 'irancell') {
			operatorSelected = setting?.irancell_sms_cost;
		} else if (operator === 'mci') {
			operatorSelected = setting?.mci_sms_cost;
		} else {
			operatorSelected = setting?.other_sms_cost;
		}
		const smsCount = Math.ceil((text.length - 70) / 76);
		const price = Math.max(1, smsCount + 1) * count * operatorSelected;
		return price;
	}
	let sumResult = calculateSMSPrice();
	let params = {
		id: null,
		province_id: province,
		location: location,
		neighbourhood_id: neighborhoodId,
		gender: gender === 'man' ? 0 : 1,
		job_id: selectJobs,
		jobs: jobs,
		operator: operator,
		media_id: selectedPlatformId,
		media_type_id: selectedPlatform === 'sms' ? 'sms' : selectedMediaTypeId,
		content_status: 0,
		age_id: selectAge,
		age: age,
		text: text,
		price: sumResult,
		count: count,
	};

	useEffect(() => {
		axios<IResponse<ISmsPanel[]>>({
			method: 'get',
			url: '/locations',
		}).then(async res => {
			if (res.data.success) {
				setLocation(res.data.data);
			}
		});
		axios<IResponse<IJobsSelectBox[]>>({
			method: 'get',
			url: '/options/job',
		}).then(async res => {
			if (res.data.success) {
				setJobs(res.data.data);
			}
		});
		axios<IResponse<IJobsSelectBox[]>>({
			method: 'get',
			url: '/options/campaign_age',
		}).then(async res => {
			if (res.data.success) {
				setAge(res.data.data);
			}
		});
		axios<IResponse<string[]>>({
			method: 'get',
			url: '/settings/',
		}).then(async res => {
			if (res.data.success) {
				setSetting(res.data.data);
			}
		});
	}, []);

	const isPost = selectedContentType === 'post';

	return (
		<BasicModal
			className={`h-auto ${isPost ? 'max-w-[720px]' : 'max-w-[70%]'}`}
			open={open}
			onClose={onClose}
			titleKey="add_sms_panel_modal"
			titleValues={{
				contentType: t(selectedContentType as string),
			}}
		>
			<div className="flex w-full flex-wrap justify-around gap-x-4 pt-8">
				<FormControl className="w-[48%]">
					<InputLabel id="province">{t('province')}</InputLabel>
					<Select
						className={`mb-6 ${selectJobs ? 'opacity-45' : ''}`}
						labelId="province"
						type="number"
						onChange={(e: SelectChangeEvent<number>) => {
							setProvince(Number(e.target.value));
							setSelectJobs('');
						}}
						disabled={selectJobs ? true : false}
						id="province"
						label={t('province')}
					>
						{location?.map(item => {
							if (item.type === 'province') {
								return <MenuItem value={item.id}>{item.title}</MenuItem>;
							}
						})}
					</Select>
				</FormControl>
				<FormControl className="w-[48%]">
					<InputLabel id="demo-simple-select-label">{t('jobs')}</InputLabel>
					<Select
						className={`mb-6 ${province ? 'opacity-45' : ''}`}
						labelId="demo-simple-select-label"
						id="demo-simple-select"
						onChange={(e: SelectChangeEvent<string>) => {
							setSelectJobs(e.target.value);
							setProvince(null);
						}}
						disabled={province ? true : false}
						label={t('jobs')}
					>
						{jobs?.map(item => <MenuItem value={item.id}>{item.title}</MenuItem>)}
					</Select>
				</FormControl>
				<FormControl className="w-[48%]">
					<InputLabel id="demo-simple-select-label">{t('gender')}</InputLabel>
					<Select className="mb-6" labelId="demo-simple-select-label" onChange={(e: SelectChangeEvent<string>) => setGender(e.target.value)} id="demo-simple-select" label={t('gender')}>
						<MenuItem value={'man'}>{t('man')}</MenuItem>
						<MenuItem value={'woman'}>{t('woman')}</MenuItem>
					</Select>
				</FormControl>
				{/* <FormControl className="w-[48%]">
					<InputLabel id="neighborhood">{t('neighborhood')}</InputLabel>
					<Select className="mb-6" labelId="neighborhood" onChange={(e: SelectChangeEvent<string>) => setNeighborhoodId(e.target.value)} id="neighborhood" label={t('neighborhood')}>
						{neighborhoods?.map(item => {
							if (item.type === 'neighborhood') {
								return <MenuItem value={item.id}>{item.title}</MenuItem>;
							}
						})}
					</Select>
				</FormControl> */}
				<FormControl className="w-[48%]">
					<InputLabel id="demo-simple-select-label">{t('operator')}</InputLabel>
					<Select className="mb-6" labelId="demo-simple-select-label" onChange={(e: SelectChangeEvent<string>) => setOperator(e.target.value)} id="demo-simple-select" label={t('operator')}>
						<MenuItem value={'irancell'}>{t('Irancell')}</MenuItem>
						<MenuItem value={'mci'}>{t('hamrah_aval')}</MenuItem>
						<MenuItem value={'other'}>{t('other_operator')}</MenuItem>
					</Select>
				</FormControl>
				<FormControl className="w-[48%]">
					<InputLabel id="demo-simple-select-label">{t('age')}</InputLabel>
					<Select className="mb-6" labelId="demo-simple-select-label" onChange={(e: SelectChangeEvent<string>) => setSelectAge(e.target.value)} id="demo-simple-select" label={t('age')}>
						{age?.map(item => <MenuItem value={item.id}>{item.title}</MenuItem>)}
					</Select>
				</FormControl>
				<Box className="relative w-full">
					<TextField placeholder={t('text_message')} onChange={e => setText(e.target.value)} multiline fullWidth rows={6} maxRows={4} />
					<span className="absolute bottom-1 left-2 text-xs text-text-disabled">{getFarsiNumber(text.length)}</span>
				</Box>
			</div>
			<Box className="mt-5 flex justify-between">
				<div className="flex w-[48%] items-center justify-between rounded-md bg-blue-200 p-4">
					<Typography>{t('count')}</Typography>
					<TextField type="number" onChange={(e: ChangeEvent<HTMLInputElement>) => setCount(Number(e.target.value))} className="border border-red-600" />
				</div>
				<div className="flex w-[48%] items-center justify-between rounded-md bg-blue-200 p-4">
					<Typography>{t('amount')}</Typography>
					<Typography>{isNaN(sumResult) ? 0 : sumResult} تومان</Typography>
				</div>
			</Box>
			<Box className="mt-5 flex flex-col items-center justify-center">
				<div className="flex w-[48%] items-center justify-between">
					<Typography className="w-full bg-blue-100 p-4 text-center">{t('oprator')}</Typography>
					<Typography className="w-full bg-blue-200 p-4 text-center">{t('count')}</Typography>
				</div>
				<div className="flex w-[48%] items-center justify-between p-4">
					<Typography>{t('Irancell')}</Typography>
					<Typography>
						{setting?.irancell_sms_cost} {t('tooman')}
					</Typography>
				</div>
				<div className="flex w-[48%] items-center justify-between p-4">
					<Typography>{t('hamrah_aval')}</Typography>
					<Typography>
						{setting?.mci_sms_cost} {t('tooman')}{' '}
					</Typography>
				</div>
				<div className="flex w-[48%] items-center justify-between p-4">
					<Typography>{t('other_operator')}</Typography>
					<Typography>
						{setting?.other_sms_cost} {t('tooman')}
					</Typography>
				</div>
			</Box>
			<Button
				className="my-5"
				onClick={() => {
					handleSaveNotSocial(params);
				}}
				fullWidth
			>
				{t('register')}
			</Button>
		</BasicModal>
	);
};

export default SmsPanelModal;
